import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { getCurrentFlight } from '../selectors/screen';

/*
 * Личные чаты (1-на-1) ВРЕМЕННО отключены (Рощин): снижаем нагрузку на БД IS.
 * Скрываем их в списке чатов на клиенте (в т.ч. устаревшие из персиста), пока бэкенд
 * их и так не отдаёт. Вернуть — выставить true (и снять флаги в backend/ComposeDialog).
 */
const PERSONAL_CHATS_ENABLED = false;

export const isMessengerAllowed = (state) => get(state, 'routesDeclaration.options.allowMessenger', false);

// Список чатов с учётом отключённых личных чатов (личные отфильтрованы).
const visibleChats = (chats) => (PERSONAL_CHATS_ENABLED ? chats : (chats || []).filter((chat) => chat.type !== 'personal'));

export const getMessengerUnreadCount = (state) =>
    visibleChats(get(state, 'messenger.chats', [])).reduce((sum, chat) => sum + (chat.unreadCount || 0), 0);

const findFlightChat = (chats, planFlightId) =>
    (chats || []).find((chat) => chat.type === 'forum' && chat.planFlightId != null && String(chat.planFlightId) === String(planFlightId));

export const getMessengerUnreadCountForFlight = (state, planFlightId) => {
    if (planFlightId == null) {
        return 0;
    }

    const chat = findFlightChat(get(state, 'messenger.chats', []), planFlightId);

    return chat ? chat.unreadCount || 0 : 0;
};

/** Счётчик для кнопки «Сообщения» в сайдбаре: в ПЗ — только чат текущего рейса, иначе — все чаты. */
export const getMessengerSidebarUnreadCount = (state) => {
    const currentFlightId = get(getCurrentFlight(state), 'id');

    if (currentFlightId != null) {
        return getMessengerUnreadCountForFlight(state, currentFlightId);
    }

    return getMessengerUnreadCount(state);
};

export const useMessengerAllowed = () => useSelector(isMessengerAllowed);

export const useMessengerUnreadCount = () => useSelector(getMessengerUnreadCount);

export const useMessengerSidebarUnreadCount = () => useSelector(getMessengerSidebarUnreadCount);

export const useMessengerStatus = () => useSelector((state) => get(state, 'messenger.status', 'idle'));

export const useMessengerChats = () =>
    useSelector((state) => {
        const search = (get(state, 'messenger.search', '') || '').trim().toLowerCase();
        const chats = visibleChats(get(state, 'messenger.chats', []));

        if (!search) {
            return chats;
        }

        return chats.filter((chat) => (chat.title || '').toLowerCase().includes(search));
    });

export const getMessengerFlightScopePlanFlightId = (state) => get(state, 'messenger.flightScopePlanFlightId', null);

export const isMessengerFlightScoped = (state) => {
    const planFlightId = getMessengerFlightScopePlanFlightId(state);
    const currentFlightId = get(getCurrentFlight(state), 'id');

    return planFlightId != null && currentFlightId != null && planFlightId === currentFlightId;
};

export const useMessengerFlightScopePlanFlightId = () => useSelector(getMessengerFlightScopePlanFlightId);

export const useMessengerFlightScoped = () => useSelector(isMessengerFlightScoped);

export const useMessengerActiveChat = () => useSelector((state) => get(state, 'messenger.activeChat', null));

export const useMessengerSearch = () => useSelector((state) => get(state, 'messenger.search', ''));

export const useMessengerThread = (chat) =>
    useSelector((state) => (chat ? get(state, `messenger.messagesByChat.${chat.type}_${chat.id}`, []) : []));

export const useMessengerRecipients = () => useSelector((state) => get(state, 'messenger.recipients', []));
